import loaderGif from '../../assets/default_lp_loader.gif';

const LoadingScreen = () => {
    return <div className="loading-container">
        <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="254px"
      height="244px"
      viewBox="0 0 254 244"
      enableBackground="new 0 0 254 244"
      xmlSpace="preserve"
    >
      <image
        style={{width: '245px', height: '245px'}}
        href={loaderGif}
      />
    </svg>
        </div>
}
export default LoadingScreen;

